module.exports = __webpack_public_path__ + "static/project5-4ba1e3a579ae71cc20de4e43caff927e.jpg";